/*--------------------------------------------------------------------------\
    reserve.js

    Description
      JavaScript for ReservationAdBoss.

    Copyrights- (C) Copyright 2007-2012 Software Consulting Services, LLC (SCS).
\--------------------------------------------------------------------------*/

/* Reservation Global Variables */

// gblParams are used to store off the last search
// so we can perform the exact same search if the user chooses Toggle Zones,
// even if they have modified something in the search box
var RESERVE = { "gblParams": null,
                "calendarVar": null,
                "validDays": [ 0, 1, 2, 3, 4, 5, 6 ],
                "toggleZonesFlag": false,
                "defaultSalesPerson": "",
                "products": null,
                "pages": null,
                "zones": null,
                "bubble": null,
                "zoneTimeoutId": null,
                "pageTimeoutId": null };

var clickedObj = null;
var pageManager = null;

function getProduct( productId ) {
  var i = findValue( map( itemgetter( "productid" ), RESERVE.products ),
                     productId );
  return i == -1 ? null : RESERVE.products[i];
}

function productIsZoned( productId ) {
  var prod = getProduct( productId );
  return prod ? prod.productiszoned : false;
}

function getPage( productId, positionId ) {
  var page = null;

  forEach( RESERVE.pages,
           function( p ) {
               if ( ( p.productid == productId ) &&
                    ( p.position == positionId ) ) {
                 page = p;
               }
           } );
  return page;
}

/**
 * Find the zone object by a given id.
 */
function getZone( zoneId ) {
  var zone = null;

  forEach( RESEVE.zones,
           function( z ) {
             if ( z.zoneid == zoneId ) {
               zone = z;
             }
           } );
  return zone;
}

function pageIsZoned( productId, positionId ) {
  var page = getPage( productId, positionId );
  return page ? page.pageiszoned : false;
}

function getPages( productId ) {
  return filter( function( p ) { return p.productid == productId; },
                 RESERVE.pages );
}

function updateValidDays() {
  var productId = getSelectedValue( $( "sel_product" ) ),
      pageId = getSelectedValue( $( "sel_position" ) ),
      zoneIdList = getZones(),
      validZoneDays = [];

  RESERVE.validDays = [];

  if ( productId == "" ) {
    forEach( RESERVE.pages,
             function( p ) {
               RESERVE.validDays = union( RESERVE.validDays,
                                          p.validDays );
             } );
  }

  if ( productId != "" && pageId == "" ) {
    forEach( getPages( productId ),
             function( p ) {
               RESERVE.validDays = union( RESERVE.validDays,
                                          p.validDays );
             } );
  }

  if ( productId != "" && pageId != "" ) {
    RESERVE.validDays = getPage( productId, pageId ).validDays;
  }

  if ( isNotEmpty( zoneIdList ) ) {
    forEach( zoneIdList,
             function( z ) {
               var zone = getZone( z );
               validZoneDays = union( validZoneDays, z.validDays );
             } );
    RESERVE.validDays = intersect( RESERVE.validDays, validZoneDays );
  }
  
  RESERVE.calendarVar.refresh();
}

/**
 * Convert a response for a page or zone to a valid days array.  They come back
 * as individual fields.
 */
function setValidDaysArray( obj ) {
  var days = [ "sun", "mon", "tue", "wed", "thu", "fri", "sat" ],
      c = count();

  obj.validDays = [];

  forEach( days,
           function( d ) {
             var i = c.next();
             if ( obj[d] ) {
               obj.validDays.push( i );
             }
           } );
}

function loadProducts() {
  var productSelect = $( "sel_product" );

  getJSON( "getproductlist",
           function( obj ) {
             RESERVE.products = obj.products;
             RESERVE.pages = obj.pages;

             /* Convert the response from the backend into an array */
             forEach( RESERVE.pages, setValidDaysArray );
             forEach( RESERVE.products,
                      function( p ) {
                        addOption( productSelect, p.productid, p.description );
                      } );

             updateValidDays();
           } );
}

function processProductChange() {
  var productId = getSelectedValue( $( "sel_product" ) ),
      pageSelect= $( "sel_position" );

  replaceChildNodes( pageSelect );
  pageSelect.length = 0;

  if ( productId != "" ) {
    addOption( pageSelect, "", "All Pages" );
    removeElementClass( pageSelect, "scs_gray" );
    forEach( getPages( productId ),
             function( p ) {
               addOption( pageSelect, p.position, p.description );
             } );
  }
  else {
    addElementClass( pageSelect, "scs_gray" );
    addOption( pageSelect, "", getLangString( "PLEASECHOOSEAPRODUCT" ) );
  }

  getZoneList();
}

function clearZoneList() {
  var zoneSelect = $( "sel_zones" );

  replaceChildNodes( zoneSelect );
  zoneSelect.length = 0;
  addElementClass( zoneSelect, "scs_gray" );
  addOption( zoneSelect, "", getLangString( "PLEASECHOOSEAZONE" ) );
}

function zonesSelected() {
  var zoneList = $( "sel_zones" );

  for ( var i = 0 ; i < zoneList.options.length ; i++ ) {
    if ( ( zoneList.options[ i ].selected ) &&
         ( zoneList.options[ i ].value != "" ) ) {
      return true;
    }
  }
  return false;
}

function pageSelected() {
  var pageList = $( "sel_position" );

  for ( var i = 0 ; i < pageList.options.length ; i++ ) {
      if ( ( pageList.options[ i ].selected ) &&
           ( pageList.options[ i ].value != "" ) ) {
          return true;
      }
  }
  return false;
}

function toggleAvailable() {
  return ( ( ! zonesSelected() ) && ( ! pageSelected() ) ) ;
}

function SearchWithZones() {
  RESERVE.toggleZonesFlag = ( zonesSelected() || pageSelected() );
  Search( null, RESERVE.toggleZonesFlag );
}

function getZoneList() {
  var productId = getSelectedValue( $( "sel_product" ) ),
      positionId = getSelectedValue( $( "sel_position" ) ),
      params = { "productid": productId,
                 "positionid": positionId,
                 "date": getDates() };

  var myCallback = function( lrm ) {
    var zoneSelect = $( "sel_zones" );
      
    // If zones are found add them to the zone search box.
    if ( lrm.zones ) {
      RESERVE.zones = lrm.zonelist;
      replaceChildNodes( zoneSelect );
      zoneSelect.length = 0;
      removeElementClass( zoneSelect, "scs_gray" );

      forEach( lrm.zonelist,
               function( zone ) {
                 setValidDaysArray( zone );
                 addOption( zoneSelect, zone.zoneid, zone.zonename );
               } );
    }
    else {
      clearZoneList();
    }
    updateValidDays();
  };
  
  if ( productIsZoned( productId ) &&
       ( ( positionId == "" ) || pageIsZoned( productId, positionId ) ) ) {
    getJSON( "getzones", myCallback, params );
  }
  else {
    updateValidDays();
  }
}

function zoneListUpdate()
{
  clearTimeout( RESERVE.zoneTimeoutId );
  getZoneList();
}

function flatSelected( cal, date ) {
  if ( isUndefinedOrNull( RESERVE.zoneTimeoutId ) ) {
    RESERVE.zoneTimeoutId = setTimeout( zoneListUpdate, 1000 );
  } else {
    clearTimeout( RESERVE.zoneTimeoutId );
    RESERVE.zoneTimeoutId = setTimeout( zoneListUpdate, 1000 );
  }
}

/**
 * See if the date selected is valid.  This function is supposed to return true
 * if the date should be disabled, so we return true if findValue returns -1.
 */
function checkRABDate( date ) {
  return findValue( RESERVE.validDays, date.getDay() ) == -1;
}

function showFlatCalendar() {
  RESERVE.calendarVar = Calendar.setup( { "flat": "cal_div",
                                          "weekNumbers": false,
                                          "multiple": [],
                                          "dateStatusFunc": checkRABDate,
                                          "flatCallback": flatSelected } );
}

/* clear all selected fields in the search box */
function clearS()
{
  var adNumber = $( "adnumber" );

  if ( RESERVE.calendarVar ) {
    RESERVE.calendarVar.clearSelection();
  }

  setSelectedIndexByValue( $( "sel_product" ), ""  );
  setSelectedIndexByValue( $( "sel_position" ) , "" );
  clearZoneList();

  if ( adNumber ) {
    adNumber.value = "";
  }
}

function getDates() {
  return keys( RESERVE.calendarVar.multiple );
}

function getZones() {
  var zones = [];
  forEach( $( "sel_zones" ), function( i ) {
             if ( i.selected && i.value != "" ) {
               zones.push( i.value );
             }
           } );
  return zones;
}

/* do the search command */
function Search( refresh, toggle, drawPages ) {
  if ( isUndefinedOrNull( toggle ) ) { toggle = false; }
  if ( isUndefinedOrNull( refresh ) ) { refresh = false; }
  if ( isUndefinedOrNull( drawPages ) ) { drawPages = true; }
  var adNumber = $( "adnumber" );
  var params;
    
  if ( refresh && !isUndefinedOrNull( RESERVE.gblParams ) ) {  
    params = deepClone( RESERVE.gblParams );
    params["toggle"] = toggle;
  }
  else {  
    params = { "adnumber": adNumber ? adNumber.value : "",
               "productid": getSelectedValue( $( "sel_product" ) ),
               "position": getSelectedValue( $( "sel_position" ) ),
               "toggle": toggle,
               "date": getDates(),
               "zone": getZones() };
    RESERVE.gblParams = deepClone( params );
  }

  // Must use either an Ad Number or a product and date
  if ( ( params["adnumber"] == "" ) &&
       ( ( params["date"].length == 0 ) || 
         ( params["productid"] == "" ) ) ) {
    if ( ViewResBlockInfo || ViewResAdInfo ) {
      scs_alert( "ERROR_RES_SEARCH_1_REQ" );
    }
    else {
      scs_alert( "ERROR_RES_SEARCH_2_REQ" );
    }
   return false;
  }

  var okCallback = function( res ) {
    if ( ViewResAdInfo ) {
      sT_reserve.loadFromURL2( "spice.pl?command=reservetable" );
    }
    if ( drawPages ) {
      getJSON( "reservejson", handlePageManager );
    }
    else {
      replaceChildNodes( $('ad_content'),
                         DIV( {'class':'scs_center scs_i',
                               'style':'margin-top:30px'}, 
                              "Please click the 'Search' button if you would also like to see the pages." ) );
    }

  };

  getJSON( "reservesearch", okCallback, params );
  if (!drawPages) switchTab( { 'id': 'listings_tab' } );
}

function checkForUnplacedAds( page, pageHeaderElem ) {
  if ( page.hasunplacedads ) {
    var warning = $j( '<i class="fa fa-exclamation-triangle" style="color: #f0ad4e" role="button"></i>' ).attr( "title", "Ad(s) requested this page and were unable to be placed.\nSee the 'Listings' tab for more information." )[0];
    
    appendChildNodes( pageHeaderElem, warning );
  }
}

function convertAreaUOM( val, targetUOM ) {
  var convertedVal;

  if ( targetUOM == "INCHES" ) {
    convertedVal = val / 5184
  } else if ( targetUOM == "CM" ) {
    convertedVal = val / 803.522;
  } else if ( targetUOM == "POINTS" ) {
    convertedVal = val;
  }
  return convertedVal.toFixed( 2 );
}

function getUOMAbbr( targetUOM ) {
  if ( targetUOM == "INCHES" ) return "in";
  else if ( targetUOM == "CM" ) return "cm";
  else if ( targetUOM == "POINTS" ) return "pt";
  else return "";
}

function getUOMStr( val, targetUOM ) {
  return ( convertAreaUOM( val, targetUOM ) + " sq " + getUOMAbbr( targetUOM ) );
}

function getRemainingArea( page, uom ) {
  var spaceLeft = page.maxadarea - page.totaladarea;
  var percent = ( spaceLeft / page.maxadarea ) * 100;
  percent = percent.toFixed( 2 );
  spaceLeft = convertAreaUOM( spaceLeft, uom );
  return "Remaining Ad Area:  " + spaceLeft + " sq " + getUOMAbbr( uom ) + " (" + percent + "%)";
}


function drawPageInfo( page, pageHeaderElem ) {
  var maxAdDesc = ( ! isUndefinedOrNull( page.maxads ) &&
                    parseInt( page.maxads, 10 ) > 0 ) ? page.maxads : "No Limit",
  defaultUOM = $j("#tab1").attr("data-default-uom");

  var title = ( "Max Ads: " + maxAdDesc + "\n" +
                "Max Ad Area:  " +
                getUOMStr( page.maxadarea, defaultUOM ) + "\n" +
                "Resererved/Sold Ad Area:  " +
                getUOMStr( page.totaladarea, defaultUOM ) + "\n" +
                getRemainingArea( page, defaultUOM ) );

  var info = $j( '<i class="fa fa-info-circle fa-lg" style="color: #5bc0de" role="button"></i>' ).attr( "title", title )[0];

  appendChildNodes( pageHeaderElem, info );
}

function handlePageManager(pmObj)
{
  pmObj = readPagModJSONObject( pmObj.PagModJSON );
  pmObj.frame = $("ad_content");
  pmObj.printCommand = "resprint";
  pmObj.pageNumType = SCS_PM.NUM_TYPE_NONE;
  pmObj.id = "reserve";
  pmObj.pagesPerRow = 5;
  pmObj.drawCallback = function() {
    forEach( keys( pageManager.pages ),
             function( k ) {
               var page = pageManager.pages[k];
               var pageHeaderElem = page.getPageHeaderElement();
               if ( ! isUndefinedOrNull( pageHeaderElem ) ) {
                 drawPageInfo( page, pageHeaderElem );
                 checkForUnplacedAds( page, pageHeaderElem );
               }
             } );
  };
                 
  if( isUndefinedOrNull( pageManager ) ) {
    pageManager = new PageManager( pmObj );
    pageManager.addMenuIcon( "TOGGLE", "Toggle Zones",
                             toggleZones,toggleAvailable);
    pageManager.addPrefItem( getSelectedValue( $( "sel_product" ) ),
                             "By Product" );
  }
  else {
    pageManager.init( pmObj );    
  }

  pageManager.adTypes.adblock.label    = getLangString( "AVAILABLE" );
  pageManager.adTypes.edblock.label    = getLangString( "NOTAVAILABLE" );
  pageManager.adTypes.displayad.label  = getLangString( "SOLD" );
  pageManager.adTypes.holdad.label     = getLangString( "ONHOLD" );

  var result = pageManager.draw();

  return result;
}

function setPreviewBlock( pageId, elementId, scale ) {
  var box = pageManager.getBoxObject( elementId );
  if ( isUndefinedOrNull( box ) ) {
    window.pageManager = pageManager;
    log('pageManager couldn\'t find '+ elementId + ' in page ' + pageId );
    return;
  }
  // Page ID must be given to the object to satisfy the page info containing the pmToPx scale
  box.pageid = pageId;

  var pos = { 'x': box.leftPx(), 'y': box.topPx() };
  var size = { 'w': box.widthPx(), 'h': box.heightPx() };

  // Scale the block if the page is too big for the Hold Ad Div
  if ( scale > 1 ) {
    pos.x /= scale;
    pos.y /= scale;
    size.w /= scale;
    size.h /= scale;
  }
  
  MochiKit.Style.setElementPosition( $( 'scs_dummy_block_preview' ), pos );
  MochiKit.Style.setElementDimensions( $( 'scs_dummy_block_preview' ), size );
}

function showHoldAdDiv( blockList, pageId, runDate, blockId ) {
  // Set/reset inputs
  replaceChildNodes( $( "blockid" ) );
  forEach( blockList,
           function( b ) {
             addOption( $( "blockid" ), b.blockid, b.blockname );
           } );

  var i = 0;
  if ( blockId != "" ) {
    setSelectedIndexByValue( $( "blockid" ), blockId );
    i = objIndexOf( blockList, "blockid", blockId );
  }

  var p = pageManager.pages[pageId];
  var maxHeight = 300, scale = 0;
  var pageWidth, pageHeight;
  // Scale pages if they are too big
  if (p.heightPx() > maxHeight) {
    scale = p.heightPx() / maxHeight;
    pageWidth = p.widthPx() / scale;
    pageHeight = p.heightPx() / scale;
  } else {
    pageWidth = p.widthPx();
    pageHeight = p.heightPx();
  }
  MochiKit.Signal.disconnectAll($('blockid'));
  MochiKit.Signal.connect( 'blockid', 'onchange', function( x ) {
    var j = objIndexOf( blockList, "blockid", getSelectedValue( x.src() ) );
    if ( j != -1 ) {
      setPreviewBlock( pageId, blockList[j].elementid, scale );
    }
  } );
  MochiKit.Style.setElementDimensions($('scs_preview_page'), {'w':pageWidth, 'h':pageHeight});

  // Init to first block selected...
  setPreviewBlock(pageId, blockList[i].elementid, scale);

  document.hold_ad_form.pageid.value = pageId;
  document.hold_ad_form.customer.value = "";
  document.hold_ad_form.description.value = "";
  document.hold_ad_form.salesperson.value = RESERVE.defaultSalesPerson;
  document.hold_ad_form.rundate.value = runDate;
  holdAdFloatingDiv.setUserData( pageId );
  holdAdFloatingDiv.show();

  document.hold_ad_form.salesperson.focus();
}

function showHoldBlocksForPage( page, blockId, e ) {
  blockId = isUndefinedOrNull( blockId ) ? "" : blockId;
  var okCallback = function( res ) {
    showHoldAdDiv( res.holdblocklist, page.pageid, page.pubdate, blockId );
  };

  if ( checkPageDeadline( page.pageid ) ) {
    genericAjaxRequest( "get_hold_blocks", false, okCallback, null,
                        [ "pageid" ], [ page.pageid ], null, null, "GET", null,
                        null, true );
  }
  else {
    alertPastDeadline( page.pageid, e );
  }
}

function handlePageClick( e ) {
  var obj = pageManager.getObject( e.src() );

  if ( isUndefinedOrNull( obj ) ) {
    return false;
  }
  clearTimeout( RESERVE.pageTimeoutId );
  clearBoxes( e.src() );
  showHoldBlocksForPage( obj, null, e );
}

function clearBoxes( pageDiv ) {
  forEach( findChildElements( pageDiv, [ ".hold_only_box" ] ), removeElement );
}

function showBox( pageDiv, boxCycle ) {
  var box = boxCycle.next();
  var element = pageManager.elements[box.elementid];
  var boxNode = box.getBoxNode();
  addElementClass( boxNode, "hold_only_box" );
  var existingMouseOver = boxNode.onmouseover || noop;

  /**
   * Pause the animation if the user mouses over a block
   * that we draw and resume after a mouse out or 3 seconds,
   * whichever comes first.
   */
  connect( boxNode, "onmouseover", function() {
    clearTimeout( RESERVE.pageTimeoutId );
    RESERVE.pageTimeOutId = null;
    existingMouseOver();
    RESERVE.pageTimeoutId = setTimeout( function() {
      removeElement( boxNode );
      showBox( pageDiv, boxCycle );
    }, 3000 );
  } );

  connect( boxNode, "onmouseout", function() {
    clearTimeout( RESERVE.pageTimeoutId );
    RESERVE.pageTimeOutId = null;
    RESERVE.pageTimeoutId = setTimeout( function() {
      removeElement( boxNode );
      showBox( pageDiv, boxCycle );
    }, 1500 );
  } );

  appendChildNodes( pageDiv, boxNode );

  RESERVE.pageTimeoutId = setTimeout( function() {
    removeElement( boxNode );
    showBox( pageDiv, boxCycle );
  }, 1500 );
}

function handlePageMouseOver( e ) {
  if ( RESERVE.pageTimeoutId ) {
    return;
  }

  var page = pageManager.getObject( e.src() );

  if ( isUndefinedOrNull( page ) ) {
    return false;
  }
  var holdOnlyBoxes = filter( function( b ) {
    var element = pageManager.elements[b.elementid];
    return ( !isUndefinedOrNull( element ) && element.isplaced &&
             element.blocktype == "HO" );
  }, page.getBoxes() );

  if ( isEmpty( holdOnlyBoxes ) ) {
    return;
  }

  var boxCycle = cycle( holdOnlyBoxes );

  RESERVE.pageTimeoutId = setTimeout( function() {
    showBox( e.src(), boxCycle )
  }, 1000 );
}

function handlePageMouseOut( e ) {
  if ( isChildNode( e.relatedTarget(), e.src() ) ||
       holdAdFloatingDiv.isVisible() ) {
    /**
     * Don't handle if we are on a child node or they've already on a
     * hold only block.
     */
    return;
  }

  clearTimeout( RESERVE.pageTimeoutId );
  RESERVE.pageTimeoutId = null;
  clearBoxes( e.src() );
}

function handleHoldBlockClick( e ) {
  var box = pageManager.getObject( e.src() );
  e.stopPropagation();

  if ( isUndefinedOrNull( box ) ) {
    return;
  }

  clearTimeout( RESERVE.pageTimeoutId );
  RESERVE.pageTimeoutId = null;
  // Disconnect needed because the onmouseout of a box restarts the timer.
  disconnectAll( e.src() );
  clearBoxes( box.getPageElement() );
  nd();
  showHoldBlocksForPage( box.getPage(), box.originid );
}

function handlePlaceHold( e, sel ) {
  var obj = pageManager.getObject( e.src() );
  clickedObj = obj;
  e.stopPropagation();

  if ( isUndefinedOrNull( obj ) ) {
    return;
  }

  var elem = obj.manager.elements[obj.elementid];
  if ( ( ( elem.blocktype === "AD" ) || ( elem.blocktype == "HO" ) ) &&
       elem.elemtype === "RESADBLOCK" && sel ) {
    // This is an AD block, open the Hold Ad dialog
    var blockName = trim( obj.manager.elements[obj.elementid].desctext1 );
    /* Don't even both opening the dialog if past deadline. */
    if ( checkPageDeadline( obj.pageid ) ) {
      showHoldAdDiv( [ { "blockid": obj.originid,
                         "blockname": blockName,
                         "elementid": obj.elementid } ], obj.pageid,
                     trim( obj.manager.pages[obj.pageid].pubdate ),
                     obj.originid );
    }
    else {
      alertPastDeadline( obj.pageid, e );
      pageManager.unselectBox();
    }
  }
}

function removeHold( e, sel, showDialog ) {
  var obj = pageManager.getObject( e.src() );
  clickedObj = obj;
  e.stopPropagation();

  if ( isUndefinedOrNull( obj ) ) {
    return;
  }

  var elem = obj.manager.elements[obj.elementid];
  if ( elem.ismanual ) {
    if ( showDialog ) {
      clickActionFloatingDiv.show();
    }
    else {
      removeAd( "hold" );
    }
  }
}

function handleRemoveHold( e, sel ) {
  removeHold( e, sel, false );
}

function handleHoldAdDialog( e, sel ) {
  removeHold( e, sel, true );
}

function handleRemoveAd( e, sel ) {
  var obj = pageManager.getObject( e.src() );
  clickedObj = obj;
  e.stopPropagation();

  if ( isUndefinedOrNull( obj ) ) {
    return;
  }

  var elem = obj.manager.elements[obj.elementid];
  if ( elem.elemtype == "RESADBOX" ) {
    removeAd( "ad" );
  }
}

function handleBoxClick( e, sel ) {
  e.stopPropagation();
}

function onAds(boxnum, col)
{   
  var box = pageManager.getBoxObject(boxnum);
  if (!isUndefinedOrNull(box)) switchTab( { 'id': 'ad_blocks_tab' } );
  return pageManager.scrollToBox(box);
}

function clearSelection( pageId ) {
  if ( !isUndefinedOrNull( pageId ) ) {
    var page = pageManager.pages[pageId]
    clearBoxes( $( pageManager.getPageId( page ) ) );
  }
  holdAdFloatingDiv.hide();
  pageManager.unselectBox();
  //if(!isUndefinedOrNull(window["sT_reserve"]))
  //  { sT_reserve.unhighlightRows(); }
}

function getPageDeadlineDateObj( pageId ) {
  var pageObj = pageManager.pages[pageId];
  var tmpStr = pageObj.deadlinetime;

  if ( tmpStr && tmpStr != "" ) {
    return new Date( tmpStr.substring( 0, 4 ),
                     tmpStr.substring( 4, 6 ) - 1,
                     tmpStr.substring( 6, 8 ),
                     tmpStr.substring( 8, 10 ),
                     tmpStr.substring( 10, 12 ) )
  }
  else {
    return null;
  }
}

function checkPageDeadline( pageId ) {
  var deadlineDate = getPageDeadlineDateObj( pageId );

  if ( deadlineDate ) {
    return ( new Date().getTime() <= deadlineDate.getTime() );
  }
  else {
    return true;
  }
}

function alertPastDeadline( pageId, e ) {
  var dateObj = getPageDeadlineDateObj( pageId );
  var msg = getSCSMessage( "MSG_PAST_DEADLINE", dateObj.toLocaleString() );
  if ( e ) {
    if ( RESERVE.bubble ) {
      RESERVE.bubble.dispose();
    }
    var bubble = new goog.ui.Bubble( msg );
    var elemPos = e.mouse().page;
    bubble.setPinnedCorner( goog.positioning.Corner.BOTTOM_LEFT );
    bubble.setPosition( new goog.positioning.AbsolutePosition( elemPos.x,
                                                               elemPos.y ) );
    bubble.setTimeout( 3000 );
    bubble.render();
    setStyle( bubble.getContentElement(), { "zIndex": 4 } );

    bubble.setVisible( true );
    RESERVE.bubble = bubble;
  }
  else {
    scs_alert( msg );
  }
}

function submitHoldAd()
{
  var formManager = new FormManager();
  var contents = formContents(document.hold_ad_form);
  var contentObj = keyValsToObj( contents[0], contents[1] );
  var salesPerson = contentObj["salesperson"];
  var pageId = contentObj["pageid"];

  if ( !formManager.validateForm(document.hold_ad_form ) ) {
    scs_alert( "ERROR_COMPLETEREQFIELDS" );
    return false;
  }
  else if ( ! checkPageDeadline( pageId ) ) {
    alertPastDeadline( pageId, null );
  }
  
  var myCallback = function(lrm)
  {
    /* Update the element to indicate it's a hold ad.  Then redraw the pages */
    var elem = pageManager.elements[lrm.getOther("ElementId")];
    var box = pageManager.getBoxObject( elem.boxnum );
    var page = pageManager.pages[$( "pageid" ).value];

    /* Just redo the search for hold ads placed on a special "hold only" block.
     * Eventually we'll make pagemanager more modular.
     */
    if ( elem.blocktype == "HO" ) {
      SearchWithZones();
    }
    else {
      elem.blocktype = "AD";
      elem.elemtype = "HOLDAD";
      elem.ismanual = true;
      elem.isplaced = true;
      elem.desctext1 = lrm.getOther( "AdNumber" );
      elem.cssboxcolor = pageManager.PagModColorNames.YELLOW;
      elem.boxtip = lrm.getOther( "BoxTip" );
      elem.onclick = lrm.getOther( "OnClick" );

      if ( lrm.getOther( "PageHasHoldBlocks" ) == "true" ) {
        page.onclick = "handlePageClick";
      }
      else {
        page.onclick = "";
      }
      pageManager.draw();
      var boxElem = pageManager.getBoxElement( elem.boxnum );
      pageManager.attachClickEvent( boxElem, box );
      clearSelection();
    }

    holdAdFloatingDiv.hide();
    saveDefaultSalesPerson( salesPerson )
  };
  
  genericAjaxRequest("holdad", false, myCallback, null, contents[0], contents[1]);
}

function toggleZones()
{
  RESERVE.toggleZonesFlag = !RESERVE.toggleZonesFlag;
  Search(true,RESERVE.toggleZonesFlag);
}

function removeAd( adType ) {
  if ( ! isUndefinedOrNull( clickedObj ) ) {
    var result = confirm( "You are about to remove this " + adType +
                          ".  Are you sure?" );
    if ( result == true ) {
      var obj = clickedObj;
      var page = obj.getPage();
      var elem = obj.manager.elements[obj.elementid];
      var box = obj.manager.getBoxObject( elem.boxnum );
      var keys = [ "adnumber", "pageid" ];
      var vals = [ elem.desctext1, obj.pageid ];

      var myCallback = function(lrm) {
        /* Check to see if we just need to do the search again.  If so, we're
           done here */
        if ( lrm.getOther( "NeedRefresh" ) == "true" ) {
          Search( null, RESERVE.toggleZonesFlag );
          return;
        }
        elem.blocktype = lrm.getOther( "BlockType" );
	elem.elemtype = "RESADBLOCK";
	elem.ismanual = false;
        elem.desctext1 = lrm.getOther( "Desc" );
        elem.cssboxcolor = pageManager.PagModColorNames.DARKGREEN;
        elem.boxtip = lrm.getOther( "PageTip" );
        elem.onclick = lrm.getOther( "OnClick" );
        box.originid = lrm.getOther( "BlockId" );
        if ( lrm.getOther( "PageHasHoldBlocks" ) == "true" ) {
          page.onclick = "handlePageClick";
        }
        else {
          page.onclick = "";
        }
        pageManager.draw();
        var boxElem = pageManager.getBoxElement( elem.boxnum );
        if ( boxElem ) {
          pageManager.attachClickEvent( boxElem, box );
        }
        clearSelection();
     }

     genericAjaxRequest( "removead", false, myCallback, null, keys, vals );
    }
  }
}

function makeHoldReal() {
  if ( ! isUndefinedOrNull( clickedObj ) ) {
    var result = confirm("You are about to make this hold into a real ad.  Are you sure?");
    if ( result == true ) {
      var obj = clickedObj;
      var elem = obj.manager.elements[obj.elementid];      
      var keys = [ "holdid", "boxnum", "blockid", "pageid" ];
      var vals = [ elem.desctext1, obj.boxnum, obj.originid, obj.pageid ];

      var myCallback = function(lrm) {
        // Set the correct block id
      	obj.originid = lrm.getOther( "BlockId" );
      	        	  
      	// Update the box to indicate that it's an ad.
      	var n = isUndefinedOrNull;
      	var c;
      	if ( !n( pageManager.adTypes.displayad ) && !n( pageManager.adTypes.displayad.color ) )
      	  { c = pageManager.adTypes.displayad.color; }
      	else
      	  { c = pageManager.PagModColors[ pageManager.PagModColorNames.RED ]; 
          }

      	// Change the color of the box
        var boxnum = obj.boxnum
      	var boxElem = pageManager.getBoxElement( boxnum );            	  
      	setStyle( boxElem, {'background-color':c} );
        //setStyle(boxElem, {'background':'-moz-linear-gradient(top,#fff,'+c+')'});

	// Remove old overlibs
	disconnectAll( boxElem, "onmouseover" );
	disconnectAll( boxElem, "onmouseout" );
	disconnectAll( boxElem, "onmousedown" );

	// Reset box settings
	elem.blocktype = "AD";
	elem.elemtype = "RESADBOX";
	elem.ismanual = false;
     }

     genericAjaxRequest( "makeholdreal", false, myCallback, null, keys, vals );      
    }
  }
}

function getDefaultSalesPerson() {
  var keys = [ "itemid", "type", "preftype" ];
  var vals = [ "rab_sales", "1", "06" ];

  var myCallback = function( lrm ) {
    RESERVE.defaultSalesPerson = lrm.getOther( "BlobVal" );
  };
                 
  genericAjaxRequest( "getuserpref", false, myCallback, noop, keys, vals,
                      menuManager.getLocCGI_Main() + '/spice.pl' );
}

function saveDefaultSalesPerson( salesPerson ) {
  var keys = [ "type", "preftype", "itemid", "blobval" ];
  var vals = [ "1", "06", "rab_sales", salesPerson ];

  RESERVE.defaultSalesPerson = salesPerson;

  genericAjaxRequest( "saveuserpref", false, noop, null, keys, vals,
                      menuManager.getLocCGI_Main() + "/spice.pl" );
}
